/**
 * Release HTMLCanvasElement backing stores when an editor session ends.
 * Chromium may retain large GPU buffers on detached canvases until GC;
 * zeroing dimensions is the documented way to drop backing-store memory
 * promptly (VistoeraTASK-00122).
 */

export function releaseCanvasBackingStore(canvas: HTMLCanvasElement | null | undefined): void {
  if (!canvas) return
  try {
    const ctx = canvas.getContext('2d')
    if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height)
    canvas.width = 0
    canvas.height = 0
  } catch {
    /* ignore races during unmount */
  }
}

export function releaseEditorCanvasSet(canvases: Array<HTMLCanvasElement | null | undefined>): void {
  for (const c of canvases) releaseCanvasBackingStore(c)
}

/** Drop retained undo/history ImageData arrays — JS heap only, not canvas GPU. */
export function clearImageDataHistory<T extends { mask: ImageData; image: ImageData | null }>(
  history: T[],
): void {
  history.length = 0
}
